<div class="main-container"> 
  <div class="page-content">
    <router-outlet></router-outlet>
  </div>
</div>